import { UrlConstants } from "../url.constants";
export class ApiAuthoriseConstants {
    static URL = UrlConstants.API_V2 + "Authorise";
    static FUNCTION_UPDATE_AUTHORISATION = "UpdateAutorisation";
    static FUNCTION_SET_AUTHORISATION_ITEMS = "SetAutorisationItems";
}
